// Single shared mutable state for the mobile module (one instance imported everywhere — never copied).

/**
 * Mobile UI state shared by lifecycle (index.js: initialized), sheets
 * (sheets.js: activeSheet) and toolbar (toolbar.js: secondaryExpanded).
 * All consumers import THIS object so mutations stay visible module-wide.
 *
 * @type {{ initialized: boolean, activeSheet: 'preview'|'arts'|'products'|null, secondaryExpanded: boolean }}
 */
export const state = {
  initialized: false,
  activeSheet: null, // 'preview' | 'arts' | 'products' | null
  secondaryExpanded: false,
}
